module.exports = __webpack_public_path__ + "img/01.d22f1c98.jpg";